import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable, of } from "rxjs";
import { tap } from "rxjs/operators";
import { PostDrillingConfig } from "../post-drilling/models/post-drilling.models";
import { ApplicationState } from "../applications/models/applications.models";
import { GISConfig } from "../gis/models/gis-config.model";


@Injectable({
  providedIn: 'root'
})
export class ApplicationConfigService {

	private _config: ModuleConfig = null;
	private _gisConfig: GISConfig = null;

    public alerts: SystemAlert[] = [];


    constructor(public http: HttpClient) { }


	getGISConfig(): Observable<GISConfig> {
		if (this._gisConfig != null) return of(this._gisConfig);
		return this.http.get<GISConfig>("/api/gis/config").pipe(
			tap((conf: GISConfig) => {
				this._gisConfig = conf;
			}
			)
		);
	}

    getModuleConfig(): Observable<ModuleConfig> {
        if (this._config != null) return of(this._config);
        return this.http.get<ModuleConfig>("/api/auth/getApplicationConfig").pipe(
            tap((conf: ModuleConfig) => { this._config = conf; })
        );
    }

    getSystemAlerts(): Observable<SystemAlert[]> {
        return this.http.get<SystemAlert[]>("/api/systemNotifications/alerts").pipe(
            tap((alerts: SystemAlert[]) => {
                this.alerts = alerts;
            })
        )
    }
}



export interface ModuleConfig {
    postDrilling: PostDrillingConfig;
    applications: ApplicationsConfig;
	indexing: IndexingConfig;
	expediteFees: ExpeditingConfig;
}

export interface ApplicationsConfig {
    permits: PermitApplicationsConfig;
}

export interface DocumentConfig {
    invoice: string;
    receipt: string;
}

export interface ReviewConfig {
    order: number;
    state: ApplicationState;
    group: string;
}

export interface PermitApplicationsConfig {
    documents: DocumentConfig;
    reviews: ReviewConfig[];
    dueDateConditions: DueDateConfig[];
    externalGroupsToNotify: string[];
    chiefsNameToPrint: string;
}

export interface DueDateConfig {
    expedited?: boolean;
    urban?: boolean;
    businessDays: number;
}

export interface IndexingConfig {
    bondingIndexFlowTemplates?: string[];
    newOpsIndexFlowTemplates?: string[];
}

export interface SystemAlert {
    id: number;
    title: string;
    message: string;
    startDate?: Date;
    endDate?: Date;
}

export interface ExpeditingConfig {
	flowsWithExpediting: string[];
	expediteMessage: string;
	noExpediteMessage: string;
}